import { NgModule } from "@angular/core";
import { MaterialModule } from "../material/material.module";
import { ModelIntroductionService } from "./model-introduction";
import { ModelComponentsModule } from "../model-components/model-components.module";
import { InsightsModule } from "../insights/insights.module";
import { InsightsOverlayComponent } from "./insights-overlay.component";

@NgModule({
    declarations: [
        InsightsOverlayComponent
    ],
	imports: [
        MaterialModule,
        InsightsModule,
        ModelComponentsModule
	],

	providers: [
        ModelIntroductionService
	]
})
export class AnimationModule {
}

